import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { SocialSecurityInput } from '@fmm/react-encompass-inputs';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import { SSN_REGEX } from 'src/util';

export const ConnectedSsnInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    const { id: contextId } = useAutosavingFormContext();

    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: SSN_REGEX,
            message: 'Please enter a valid SSN',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <SocialSecurityInput
            variant='outlined'
            size='small'
            fullWidth
            id={(id ?? contextId) ? `${contextId}.${name}` : name}
            {...props}
            name={name}
            value={value || ''}
            onChange={(e) => {
              const value = e.target.value;
              onChange(value);
            }}
            onBlur={onBlur}
            inputProps={{
              ...props.inputProps,
            }}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedSsnInput.displayName = 'ConnectedSsnInput';

ConnectedSsnInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  capitalize: PropTypes.bool,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
};
